/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPlayIcon20Solid = forwardRef('MediaUiAPlayIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M16.173 8.556 6.597 2.612C5.464 1.909 4 2.723 4 4.056v11.888c0 1.333 1.464 2.147 2.597 1.444l9.576-5.944a1.7 1.7 0 0 0 0-2.888Z" })));
});
